<!-- 主模板區塊 -->
<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-pallet"></i></span>{{ 'Menu.Menu.WarehousingAbnormal' | translate }}
  </h1>
  <p-card>
      <p-accordion [multiple]="true">
          <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">
              <form [formGroup]="searchForm">
                <!-- 查詢表單 -->
                <div class="p-fluid grid">
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label for="i_whNo">{{ 'ReceiptForm.Search.ReceiptNumber' | translate }}</label>
                    <p-chips id="w_whNo" formControlName="whNo" separator=","></p-chips>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label for="i_hawbNo">{{ 'WarehousingAbnormal.Form.HawbNo' | translate }}</label>
                    <p-chips id="i_hawbNo" formControlName="hawbNo" separator=","></p-chips>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label>{{ 'ReceiptForm.Search.Brand' | translate }}</label>
                    <p-multiSelect formControlName="brand"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                              [options]="brandOptions"
                              [filter]="true"
                              filterBy="label">
                    </p-multiSelect>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label>{{ 'ReceiptForm.Search.InternalBrand' | translate }}</label>
                    <p-multiSelect formControlName="internalBrand"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                              [options]="internalBrandOptions"
                              [filter]="true"
                              filterBy="label">
                    </p-multiSelect>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label>{{ 'ReceiptForm.Search.Company' | translate }}</label>
                    <p-multiSelect formControlName="orgId"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                              [options]="letterHeadOptions"
                              [filter]="true"
                              filterBy="label">
                    </p-multiSelect>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}} laas-calendar" >
                    <laas-calendar
                      #whDt
                      [title]="'ReceiptForm.Search.ReceivingDate'"
                      [enableMaxDateIsToday]="false"
                      [showRangeMode]="true"
                      [showStartMode]="true"
                      (onDateChange)="dateOnChange($event,'whDt')">
                    </laas-calendar>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}} laas-calendar" >
                    <laas-calendar
                      #notifyDt
                      [title]="'WarehousingAbnormal.Form.AbnormalNotifiedDate'"
                      [enableMaxDateIsToday]="false"
                      [showRangeMode]="true"
                      [showStartMode]="true"
                      (onDateChange)="dateOnChange($event,'notifyDt')">
                    </laas-calendar>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}} laas-calendar" >
                    <laas-calendar
                      #handleDt
                      [title]="'WarehousingAbnormal.Form.AbnormalHandledDate'"
                      [enableMaxDateIsToday]="false"
                      [showRangeMode]="true"
                      [showStartMode]="true"
                      (onDateChange)="dateOnChange($event,'handleDt')">
                    </laas-calendar>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label>{{ 'WarehousingAbnormal.Form.AbnormalType' | translate }}</label>
                    <p-dropdown formControlName="abnormalType" optionLabel="label" optionValue="value"
                      [options]="abnormalTypeOptions" styleClass="p-text-left"
                      [showClear]="false" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                    </p-dropdown>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label>{{ 'WarehousingAbnormal.Form.AbnormalNotified' | translate }}</label>
                    <p-dropdown formControlName="isNotified" optionLabel="label" optionValue="value"
                      [options]=" yesNoOptions" styleClass="p-text-left"
                      [showClear]="false" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                    </p-dropdown>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label>{{ 'WarehousingAbnormal.Form.AbnormalHandled' | translate }}</label>
                    <p-dropdown formControlName="isHandled" optionLabel="label" optionValue="value"
                      [options]=" yesNoOptions" styleClass="p-text-left"
                      [showClear]="false" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                    </p-dropdown>
                  </div>
                  <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                    <label for="formFacility">{{ 'WarehousingAbnormal.Form.Facility' | translate }}</label>
                    <laas-facility-dropdown
                      [isMultiple]="true"
                      [showFilter]="true"
                      [showToggleAll]="true"
                      formControlName="facility"
                    ></laas-facility-dropdown>
                  </div>
                </div>

                <!-- 查詢功能按鈕 -->
                <div class="grid">
                  <div class="col">
                    <button type="button" title="{{ 'Common.Button.Search' | translate }}" pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
                    <button type="button" title="{{ 'Common.Button.Reset' | translate }}" pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-4" (click)="resetBtn()" ></button>
                  </div>
                </div>
              </form>
          </p-accordionTab>
          <p-accordionTab header="{{ 'WarehousingAbnormal.Accordion.Hawb' | translate }}" [(selected)]="isHawbTableOpen">
            <ng-content *ngTemplateOutlet="hawbTableTemplate"></ng-content>
          </p-accordionTab>
          <p-accordionTab header="{{ 'WarehousingAbnormal.Accordion.Abnormal' | translate }}" [(selected)]="isAbnormalTableOpen">
            <ng-content *ngTemplateOutlet="abnormalTableTemplate"></ng-content>
          </p-accordionTab>
          <p-accordionTab header="{{ 'WarehousingAbnormal.Accordion.Ad' | translate }}" [(selected)]="isAdTableOpen">
            <ng-content *ngTemplateOutlet="adTableTemplate"></ng-content>
          </p-accordionTab>
      </p-accordion>
  </p-card>
</div>

<!-- 提貨表格 -->
<ng-template #hawbTableTemplate>
  <laas-data-table
    #hawbTable
    [expandable]="true"
    [selectable]="true"
    [dataKey]="'hawbNo'"
    [tableKey]="preferenceKeyAboutHawbNoData"
    [loading]="isLoading"
    [defaultColumns]="hawbColumns"
    [lazy]="true"
    [value]="hawbResults"
    (onRowClick)="onRowClick($event)"
    (tableOnPage)="tablePageChange($event, 'hawb')"
    (tableOnSort)="tableSort($event, 'hawb')">
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'hawbNo'">
            <div class="overflow-text">
              <a class="bold-text" href="javascript: void(0);" >{{rowData[col.field]}}</a>
            </div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
      <ng-container *ngTemplateOutlet="hawbChildTableTemplate; context: { data: rowData, index: rowIndex }"></ng-container>
    </ng-template>
  </laas-data-table>
</ng-template>

<!-- 入倉單Header -->
<ng-template #hawbChildTableTemplate let-rowData="data" let-rowIndex="index">
  <laas-data-table
    [dataKey]="'seqNo'"
    [tableKey]="preferenceKeyAboutWarehousingHeaderData"
    [selectable]="true"
    [value]="rowData.warehousingDetail"
    [defaultColumns]="hawbChildColumns"
    [paginator]="false"
    [style]="{ 'overflow-y': 'auto' }">
    <ng-template pTemplate="caption">
      <p-menubar [model]="itemMenus" styleClass="ml-2"></p-menubar>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" (click)="selectRowOnHeaderTable(rowData)">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'function'">
            <div class="overflow-text">
              <a href="javascript: void(0);" (click)="openWarehousingAbnormalHistoryDialog(rowData)">{{
                'WarehousingAbnormal.Table.History' | translate }}</a>
              <i *ngIf="hasPermissionOfWarehousingAbnormalTrackingForShippingDialog() && !rowData.isPcsrHandled"
                class="fas fa-exclamation-triangle" (click)="openWarehousingAbnormalTrackingForShippingDialog(rowData)"></i>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'importDeclarationNo'">
            <div class="overflow-text">
              <a href="javascript: void(0);">{{rowData[col.field]}}</a>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'isPrint'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'orgId'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'billCorp'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'deliveryType'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:deliveryOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'urgentFlag'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:urgentFlagOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'isGenerateFee'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'whStatus'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:whDocStatusOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'shipTerm'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:shipTermOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'shipper'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:bookingForwarderOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'whDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'expectedDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'fromCountry'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'fromCity'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allCityOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'fromArea'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allAreaOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'brand'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:brandOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'addressCode'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:pickupLocationOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'flightDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'toCity'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allCityOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'deliverySubType'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:deliverySubTypeOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'permitType'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'isDropShipment'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'isFeeCalculation'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:isFeeCalculationOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </laas-data-table>
</ng-template>

<!-- 異常Header -->
<ng-template #abnormalTableTemplate>
  <laas-data-table
    #abnormalTable
    [expandable]="true"
    [selectable]="true"
    [dataKey]="'seqNo'"
    [tableKey]="preferenceKeyAboutWarehousingAbnormalHeaderData"
    [loading]="isAbnormalLoading"
    [defaultColumns]="abnormalColumns"
    [lazy]="true"
    [value]="abnormalResults"
    (tableOnPage)="tablePageChange($event, 'abnormal')"
    (tableOnSort)="tableSort($event, 'abnormal')">
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'notifyDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'handleDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'isHandled'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:ynOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'isNotified'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:ynOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'abnormalType'">
            <div class="overflow-text">{{ rowData[col.field] | optionsMapping:abnormalTypeOptions | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
      <ng-container *ngTemplateOutlet="abnormalChildTemplate; context: { data: rowData, index: rowIndex }"></ng-container>
    </ng-template>
  </laas-data-table>
</ng-template>

<!-- 異常Detail -->
<ng-template #abnormalChildTemplate let-rowData="data" let-rowIndex="index">
  <laas-data-table
    [dataKey]="'seqNo'"
    [tableKey]="preferenceKeyAboutWarehousingAbnormalDetailData"
    [selectable]="true"
    [value]="rowData.abnormalDetail"
    [defaultColumns]="abnormalChildColumns"
    [paginator]="false"
    [style]="{ 'overflow-y': 'auto' }">
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </laas-data-table>
</ng-template>

<!-- AD Header -->
<ng-template #adTableTemplate>
  <laas-data-table
    #adTable
    [expandable]="true"
    [selectable]="true"
    [dataKey]="'seqNo'"
    [tableKey]="preferenceKeyAboutAdvisingHeaderData"
    [loading]="isAdLoading"
    [defaultColumns]="adColumns"
    [lazy]="true"
    [value]="adResults"
    (tableOnPage)="tablePageChange($event, 'ad')"
    (tableOnSort)="tableSort($event, 'ad')">
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'notifyDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'handleDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
      <ng-container *ngTemplateOutlet="adChildTemplate; context: { data: rowData, index: rowIndex }"></ng-container>
    </ng-template>
  </laas-data-table>
</ng-template>

<!-- AD Detail -->
<ng-template #adChildTemplate let-rowData="data" let-rowIndex="index">
  <laas-data-table
    [dataKey]="'seqNo'"
    [tableKey]="preferenceKeyAboutAdvisingDetailData"
    [selectable]="true"
    [value]="rowData.advisingDetail"
    [defaultColumns]="adChildColumns"
    [paginator]="false"
    [style]="{ 'overflow-y': 'auto' }">
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </laas-data-table>
</ng-template>

<!-- AD 匯入 Modal Modal -->
<ng-container *ngIf="isShowWarehousingAbnormalHandlingForPcsrModal">
  <laas-warehousing-abnormal-handling-for-pcsr [(visible)]="isShowWarehousingAbnormalHandlingForPcsrModal"
    [params]="warehousingAbnormalHandlingForPcsrParams"
    (visibleChange)="closeWarehousingAbnormalHandlingForPcsrDialog($event)"></laas-warehousing-abnormal-handling-for-pcsr>
</ng-container>

<!-- 結案/追蹤 Modal -->
<ng-container *ngIf="isShowWarehousingAbnormalTrackingForShippingModal">
  <laas-warehousing-abnormal-tracking-for-shipping [(visible)]="isShowWarehousingAbnormalTrackingForShippingModal"
    [params]="warehousingAbnormalTrackingForShippingParams"
    (visibleChange)="closeWarehousingAbnormalTrackingForShippingDialog($event)"></laas-warehousing-abnormal-tracking-for-shipping>
</ng-container>

<!-- 入倉單Header歷程 Modal -->
<ng-container *ngIf="isShowWarehousingAbnormalHistoryModal">
  <laas-warehousing-abnormal-history [(visible)]="isShowWarehousingAbnormalHistoryModal"
    [params]="warehousingAbnormalHistoryParams"
    (visibleChange)="closeWarehousingAbnormalHistoryDialog($event)"></laas-warehousing-abnormal-history>
</ng-container>

<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
